import React from "react";

const BS5_Pagination = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Pagination Component</h2>
      <p>This is the BS5_Pagination component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Pagination;
